import { StyledProps, React, withStyles, _ } from '@api';
import { Menu, MenuItem } from '@material-ui/core'

const styles = theme => ({
  menuContainer:    {
    height:          '48px',
    bottom:          '0px',
    position:        'absolute',
    width:           '100%',
    backgroundColor: 'rgba(27, 27, 27, 0.28)',
    justifyContent:  'flex-end',
    display:         'flex'
  },
  defaultTextDiv:   {
    display:    'flex',
    flex:       1,
    marginLeft: 24,
    marginTop:  12,
    fontStyle:  'italic'
  },
  defaultImageText: {
    width:         48,
    height:        20,
    fontSize:      14,
    lineHeight:    1.43,
    letterSpacing: 0.2,
    color:         '#ffffff'
  },
  moreIcon:         {
    color: '#FFF'
  },
  dropdownStyle:    {
    width: '158px'
  }
})

interface MyProps extends StyledProps {
  images
  anchorEl?: HTMLElement
  handleClose: (e) => void
  onClickUploadImage: (e) => void
  onClickSetDefault: (e, currentImage) => void
  activeImageId?: string
  onDeleteImage: (e, currentImage) => void
  defaultImageId?: string
  hex?: string
}

@(withStyles as any)(styles)
export class CarouselMenu extends React.Component<MyProps> {
  static defaultProps = {
    handleClose:        () => {},
    onClickUploadImage: () => {},
    onClickSetDefault:  () => {},
    onDeleteImage:      () => {}
  }

  render() {
    const {
            classes,
            images,
            anchorEl,
            handleClose,
            onClickUploadImage,
            onClickSetDefault,
            activeImageId,
            onDeleteImage,
            defaultImageId,
            hex
          }          = this.props
    let currentImage = _.find(images, (img) => img.id === activeImageId)
    let disableUpload = hex ? images.length >= 6 : images.length >= 5
    return (
        <div style={{width: '10px'}}>
          <Menu
              id='simple-menu'
              transformOrigin={{
                vertical:   'top',
                horizontal: 'right'
              }}
              anchorOrigin={anchorEl ? undefined : {
                vertical:   'center',
                horizontal: 'right'
              }}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              classes={{paper: classes.dropdownStyle}}
          >
            <MenuItem disabled={disableUpload} onClick={onClickUploadImage}>Upload New Image</MenuItem>
            {currentImage && !currentImage.hex && !hex && <MenuItem disabled={activeImageId === defaultImageId} onClick={(e) => { onClickSetDefault(e, currentImage) }}>Set as Default</MenuItem>}
            {currentImage && !currentImage.hex && <MenuItem onClick={(e) => onDeleteImage(e, currentImage)}>Delete Image</MenuItem>}
          </Menu>
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/libraries/components/CarouselMenu.tsx